import React, { Fragment, useState, useEffect } from 'react'
import AdminWrapper from '../AdminWrapper'
import SwitchMenuBar from '../../../Components/SwitchMenuBar/SwitchMenuBar'
import AllocationCalendar from './AllocationCalendar'

const MultipleTeacherAllocation = (props) => {
  const { job } = props.location.state
  const [campus, setCampus] = useState(null)
  const [inst, setInstitution] = useState(null)
  const [inst_logo, setInstLogo] = useState(null)

  useEffect(() => {
    const { campuses, insts } = props.location.state
    const campus = campuses.find((item) => item._id === job.campus_id)
    setCampus(campus)
    if (campus) {
      const inst = insts.find((item) => item._id === campus.institution_id)
      setInstitution(inst)

      if (inst) {
        const inst_logo = inst.logo
        setInstLogo(inst_logo)
      }
    }
  }, [props.location.state])

  return (
    <AdminWrapper>
      <Fragment>
        <SwitchMenuBar isViewAsTeacher />
        <div className='page-container-main bg-photoregister'>
          <div className='bg-gradient page-container-bg'></div>
          <div className='page-container-header'>
            <div className='page-container-header-inner'>
              <h1>Assign Teachers</h1>
            </div>
          </div>
          <div className='page-container-inner'>
            <div className='availability-table-body'>
              <div className='availability-table-body-content'>
                <div className='row mb-2'>
                  <div className='col-md-2'>
                    <img
                      //   className="md:h-24 rounded-full shadow-md"
                      className='rounded-full shadow-md imageSize'
                      src={inst_logo}
                      alt='Logo'
                    />
                  </div>
                  <div className='col-md-3'>
                    <div className='flex flex-col'>
                      <p className='font-bold text-2xl'>
                        {inst
                          ? inst.institution_name
                          : 'institution not found/deleted'}
                      </p>
                      <p className='text-base'>{job.level}</p>
                      <p className='text-base'>
                        {campus
                          ? campus.address_line1 +
                            (campus.address_line2
                              ? ', ' + campus.address_line2
                              : '')
                          : 'campus not found/deleted'}
                      </p>
                    </div>
                  </div>

                  <div className='col-md-3'>
                    <div className='flex flex-col'>
                      <h3 className='font-extrabold text-2xl'>Date and Time</h3>
                      <p className='text-base'>
                        Arrival time: {job.arrival_time}
                      </p>
                      <p className='text-base'>Start time: {job.start_time}</p>
                      <p className='text-base'>End time: {job.end_time}</p>
                    </div>
                  </div>

                  <div className='col-md'>
                    <div className='flex flex-col justify-center'>
                      <h3 className='font-extrabold text-2xl'>
                        {job.paid_teaching_hours +
                          job.paid_nonteaching_hours +
                          ' '}{' '}
                        Hours
                      </h3>
                      <p className='text-base'>
                        {job.paid_teaching_hours + ' '}Teaching hours
                      </p>
                      <p className='text-base'>
                        {job.paid_nonteaching_hours === null
                          ? 0
                          : job.paid_nonteaching_hours + ' '}{' '}
                        Non-teaching hours
                      </p>
                    </div>
                  </div>
                </div>
                <div className='mt-5 row'>
                  <div className='col'>
                    <AllocationCalendar job={job}></AllocationCalendar>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    </AdminWrapper>
  )
}

export default MultipleTeacherAllocation
